import { useDrag } from 'react-dnd';

type DraggableCardProps = {
  data: string | number;
  children: React.ReactNode;
};

const DraggableCard = ({ data, children }: DraggableCardProps) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'CARD',
    item: data,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div ref={drag} style={{ opacity: isDragging ? 0.5 : 1, cursor: 'grab' }}>
      {children}
    </div>
  );
};

export default DraggableCard;
